<template>
    <div>
             
    <Banner></Banner>
    <ReportsList></ReportsList>
    <!-- <Tabs></Tabs> -->
    <!-- <App></App> -->
    </div>
</template>

<script>
export default {
components: {
    Banner: () => import("../components/SdgsReports/Banner/Banner.vue"),
     ReportsList: () => import("../components/SdgsReports/ReportsList/ReportsList.vue"),
    Tabs: () => import("../components/AppMarket/Tabs/Tabs.vue"),
    App: () => import("../components/AppMarket/App/App.vue"),
  },
}
</script>

<style>

</style>